// Основные цвета приложения
export const COLORS = {
  primary: '#007bff',
  secondary: '#6c757d',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
  light: '#f8f9fa',
  dark: '#343a40',
  white: '#ffffff',
  black: '#000000',
  gray: '#6c757d',
  lightGray: '#e9ecef',
  darkGray: '#495057'
};

// Размеры экранов для медиа-запросов
export const BREAKPOINTS = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1200px'
};

// Настройки GSAP анимаций
export const GSAP_CONFIG = {
  header: {
    background: 'rgba(23, 23, 23, 1)',
    transparent: 'rgba(23, 23, 23, 0)',
    scrollTrigger: {
      trigger: '#hero',
      start: '40% 70%',
      end: '20% top',
      scrub: true
    }
  }
};

// Настройки компании
export const COMPANY_INFO = {
  name: 'ФАРМПРОФИПАК',
  description: 'Компания по производству и поставке фармацевтической продукции',
  contact: {
    email: 'info@pharmprofipack.ru',
    phone: '+7 (XXX) XXX-XX-XX',
    address: 'Россия'
  }
};

// Настройки политики конфиденциальности
export const PRIVACY_POLICY = {
  sections: [
    {
      title: '1. Общие положения',
      content: 'Настоящая политика конфиденциальности описывает, как компания "ФАРМПРОФИПАК" собирает, использует и защищает персональную информацию пользователей нашего сайта.'
    },
    {
      title: '2. Сбор информации',
      content: 'Мы можем собирать следующую информацию:',
      list: [
        'Имя и контактная информация',
        'Демографическая информация',
        'Информация о предпочтениях и интересах',
        'Другая информация, относящаяся к опросам клиентов и/или предложениям'
      ]
    },
    {
      title: '3. Использование информации',
      content: 'Собранная информация используется для:',
      list: [
        'Улучшения наших продуктов и услуг',
        'Персонализации пользовательского опыта',
        'Улучшения обслуживания клиентов',
        'Обработки транзакций',
        'Отправки периодических электронных писем'
      ]
    },
    {
      title: '4. Безопасность',
      content: 'Мы принимаем соответствующие меры безопасности для защиты вашей личной информации. Мы используем шифрование для защиты конфиденциальной информации, передаваемой онлайн.'
    },
    {
      title: '5. Файлы cookie',
      content: 'Наш сайт может использовать файлы cookie для улучшения пользовательского опыта. Вы можете настроить свой браузер для отказа от файлов cookie.'
    },
    {
      title: '6. Раскрытие информации третьим лицам',
      content: 'Мы не продаем, не обмениваем и не передаем вашу личную информацию третьим лицам. Это не включает доверенных третьих лиц, которые помогают нам в работе сайта.'
    },
    {
      title: '7. Согласие',
      content: 'Используя наш сайт, вы соглашаетесь с нашей политикой конфиденциальности.'
    },
    {
      title: '8. Изменения в политике конфиденциальности',
      content: 'Мы можем время от времени обновлять нашу политику конфиденциальности. Мы уведомим вас о любых изменениях, разместив новую политику на этой странице.'
    },
    {
      title: '9. Контактная информация',
      content: 'Если у вас есть вопросы по поводу данной политики конфиденциальности, пожалуйста, свяжитесь с нами.'
    }
  ]
};

// Настройки навигации
export const NAVIGATION = {
  menuItems: [
    { name: 'Главная', path: '/', id: 'hero' },
    { name: 'О нас', path: '/about', id: 'about' },
    { name: 'Работы', path: '/work', id: 'work' },
    { name: 'Примеры', path: '/primer', id: 'primer' },
    { name: 'GRDB', path: '/grdb', id: 'grdb' }
  ]
};

// Настройки метаданных
export const META = {
  title: 'ФАРМПРОФИПАК - Производство фармацевтической продукции',
  description: 'Компания ФАРМПРОФИПАК специализируется на производстве и поставке качественной фармацевтической продукции',
  keywords: 'фармацевтика, производство, лекарства, медикаменты, ФАРМПРОФИПАК'
};

// Настройки Telegram API
export const TELEGRAM_CONFIG = {
  token: '6779032013:AAGSGDsPqf_SkMoKrvwVJsVfpX_df1aZBW4',
  chatId: '-4045547765',
  get uriApi() {
    return `https://api.telegram.org/bot${this.token}/sendMessage`;
  }
};
